import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'


import PropTypes from 'prop-types'
import MasonryGridItem from './masonry-grid-item/index'
import useStyles from './masonry-grid.styles'

const MasonryGridBlock = ({ activities, reverse }) => {
  const styles = useStyles({ count: activities.length })
  return (
    <Box className={`${styles.masonryGridBlock} ${reverse ? 'reverse' : ''}`}>
      {activities.map((item, index) => (
        <MasonryGridItem
          className={styles.masonryGridBlockItem}
          key={item.sys.id}
          {...item}
          large={index === 0}
          index={index}
        >{`item ${index + 1}`}
        </MasonryGridItem>
      ))}
    </Box>
  )
}

MasonryGridBlock.propTypes = {
  reverse: PropTypes.bool,
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      sys: PropTypes.shape({
        id: PropTypes.string,
      }),
      headline: PropTypes.string,
      caption: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string,
        description: PropTypes.string,
      }),
    }),
  ),
}

const MasonryGrid = (props) => {
  const {
    activitiesHeadline,
    activitiesSummary,
    activitiesCollection,
  } = props
  const styles = useStyles()

  const hasActivities = activitiesCollection && !!activitiesCollection.items?.length
  const block1 = activitiesCollection && activitiesCollection.items?.slice(0, 3)
  const block2 = activitiesCollection && activitiesCollection.items?.length > 3
    ? activitiesCollection.items?.slice(3, 6)
    : []

  return (
    <Box className={styles.root}>
      <Container>
        <Typography variant="h4" variantMapping={{ h4: 'h2' }} className={styles.headline}>{activitiesHeadline}</Typography>
        <Typography variant="body1" className={styles.summary}>{activitiesSummary}</Typography>
        {hasActivities && (
          <Box className={styles.gridContainer}>
            <MasonryGridBlock activities={block1} />
            {!!block2.length && (<MasonryGridBlock activities={block2} reverse />)}
          </Box>
        )}
      </Container>
    </Box>
  )
}

MasonryGrid.propTypes = {
  activitiesHeadline: PropTypes.string,
  activitiesSummary: PropTypes.string,
  activitiesCollection: PropTypes.shape({
    total: PropTypes.number,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        sys: PropTypes.shape({
          id: PropTypes.string,
        }),
        headline: PropTypes.string,
        caption: PropTypes.string,
        image: PropTypes.shape({
          url: PropTypes.string,
          description: PropTypes.string,
        }),
      }),
    ),
  }),
}

MasonryGrid.defaultProps = {}

export default MasonryGrid
